import { createStyles, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { Button, BoxWrapper } from 'components/Base';
import Routes from 'consts/routes';
import { SearchRounded as SearchRoundedIcon } from '@material-ui/icons';
import LinkCard from './LinkCard';
import { useHistory } from 'react-router-dom';
import api from 'api';
import { Hub } from '@mui/icons-material';
import { useTheme } from '@material-ui/styles';

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      overflow: 'hidden'
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      height: '100%'
    }
  })
);

const InvestmentAnalyserTile = () => {
  const theme = useTheme() as any;
  const classes = useStyles();
  const history = useHistory();
  const [itemCount, setItemCount] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [canCreateAnalysis, setCanCreateAnalysis] = useState(true);

  if (!loaded) {
    api.getResearchItems().then((response: any) => {
      const count = response.data.length;
      setItemCount(count);
      setLoaded(true);
    });
  }

  return (
    <BoxWrapper title="Research" noBorder className={classes.box}>
      <LinkCard
        clickable={false}
        icon={
          <SearchRoundedIcon
            style={{ transform: 'rotate(90deg)', fontSize: 48 }}
          />
        }
      >
        <div className={classes.flex}>
          <div className="dashboardLink">Investment Analyser</div>
        </div>
        <p style={{ maxWidth: '250px' }}>
          Analyse and compare investment funds and Model Portfolios
        </p>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <Button
            onClick={() => {
              if (!canCreateAnalysis) {
                return;
              }
              setCanCreateAnalysis(false);
              history.push({
                pathname: Routes.INVESTMENT_ANALYSER,
                state: { newAnalysis: true }
              });
            }}
            type="button"
          >
            New analysis
          </Button>
          {itemCount > 0 ? (
            <Button
              onClick={() => history.push(Routes.INVESTMENT_ANALYSER)}
              type="button"
            >
              Existing analysis
            </Button>
          ) : (
            <></>
          )}
        </div>
      </LinkCard>
      <LinkCard
        onClick={() => history.push(Routes.MPS_HUB.BASE)}
        icon={
          <Hub
            style={{
              fontSize: 48,
              color: theme.palette.baseColors.secondary
            }}
          />
        }
      >
        <div className={classes.flex}>
          <div className="dashboardLink">MPS Hub</div>
        </div>
        <p style={{ maxWidth: '250px' }}>
          Insight into MPS and DFM providers and their portfolios
        </p>
      </LinkCard>
    </BoxWrapper>
  );
};

export default InvestmentAnalyserTile;
